import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ApolloProvider } from "@apollo/client";
import { PostHogProvider } from "@posthog/react";
import App from "./App";
import { AuthProvider } from "./contexts/AuthContext";
import { apolloClient } from "./graphql/client";
import "./i18n/config"; // Initialize i18n
import "./index.css";

const posthogKey = import.meta.env.VITE_POSTHOG_PROJECT_TOKEN;
const posthogOptions = {
  api_host: import.meta.env.VITE_POSTHOG_HOST ?? "https://us.i.posthog.com",
  defaults: "2026-05-30",
  // Autocapture (pageviews, clicks) is on by default — that's the point of the
  // frontend SDK: "what do they click / ignore" for free. Session replay stays
  // off until we explicitly want the Hotjar-style layer.
  disable_session_recording: true,
} as const;

// Render with PostHog only when a key is configured, so local/CI without the
// env var behaves exactly like before (mirrors the backend no-op behaviour).
const tree = (
  <React.StrictMode>
    <BrowserRouter>
      <ApolloProvider client={apolloClient}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </ApolloProvider>
    </BrowserRouter>
  </React.StrictMode>
);

ReactDOM.createRoot(document.getElementById("root")!).render(
  posthogKey ? (
    <PostHogProvider apiKey={posthogKey} options={posthogOptions}>
      {tree}
    </PostHogProvider>
  ) : (
    tree
  ),
);
